import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { format } from "timeago.js";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useDispatch, useSelector } from "react-redux";
import { deleteComment } from "../redux/apiCalls";
import { publicRequest } from "../requestMethods";

const Container = styled.div`
  display: flex;
  gap: 10px;
  margin: 30px 0px;
  color: ${({ theme }) => theme.text};
`;
const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

const Name = styled.span`
  font-size: 13px;
  font-weight: 500;
  display: flex;
`;

const Date = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.textSoft};
  margin-left: 5px;
`;

const Text = styled.span`
  font-size: 14px;
`;

const DeleteButton = styled.div`
  align-self: flex-end;
  cursor: pointer;
`;

const CommentDesc = styled.div`
  display: flex;

  justify-content: space-between;
`;
const Comment = ({ comment, currentUser }) => {
  const [channel, setChannel] = useState({});
  const { currentVideo } = useSelector((state) => state.video);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchComment = async () => {
      const res = await publicRequest.get(`/users/find/${comment.userId}`);
      setChannel(res.data);
    };
    fetchComment();
  }, [comment.userId]);

  const handleDelete = (e) => {
    e.preventDefault();
    deleteComment(comment?._id, dispatch);
  
  };

  return (
    <Container>
      <Avatar
        src={
          channel?.img
            ? channel?.img
            : "https://refugedulacdulou.com/wp-content/uploads/2019/01/avatar-anonyme.png"
        }
      />
      <Details>
        <CommentDesc>
          <Name>
            {channel?.name} <Date>{format(comment?.createdAt)}</Date>
          </Name>
          {currentUser?._id === comment?.userId ||
          currentUser?._id === currentVideo?.userId ? (
            <DeleteButton onClick={handleDelete}>
              <DeleteForeverIcon />
            </DeleteButton>
          ) : (
            <></>
          )}
        </CommentDesc>

        <Text>{comment?.desc}</Text>
      </Details>
    </Container>
  );
};

export default Comment;
